export default __webpack_public_path__ + "static/media/winning.f4bc8f5a.png";